module.exports = __webpack_public_path__ + "img/summer.20db0bcf.png";